export const SIZE_CLASSES = {
  small: 'avatar-small',
  medium: 'avatar-medium',
  large: 'avatar-large',
  xlarge: 'avatar-xlarge'
};

export const FRAME_CLASSES = {
  legend: 'avatar-frame-legend',
  superuser: 'avatar-frame-superuser',
  moderator: 'avatar-frame-moderator',
  librarian: 'avatar-frame-librarian',
  donor: 'avatar-frame-donor'
};

export const RATING_GRADIENTS = {
  elite: 'linear-gradient(135deg, #ffaa44, #ffcc66)',
  gold: 'linear-gradient(135deg, #c0c0c0, #a0a0a0)',
  silver: 'linear-gradient(135deg, #cd7f32, #b87333)',
  default: 'linear-gradient(135deg, #2a4a2a, #1a3a1a)'
};

export const RATING_THRESHOLDS = {
  elite: 1000,
  gold: 500,
  silver: 100
};